export default "__VITE_ASSET__O$Fo1gXQ__"